import BASModal from '../../../components/Finance/BAS/BASModal'
import List from '../../../components/Finance/BAS/List'
import PageTitle from '../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function BAS(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item href="/bas">BAS</Breadcrumb.Item>
              <Breadcrumb.Item>BAS</Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Business Activity Statement'}
              subtitle={'Check Business Activity Statement'}
              color={'#FF6138'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <BASModal {...props} />
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

BAS.propTypes = {}
BAS.defaultProps = {}

export default BAS
